// Ambient Layer — VhsOverlay
// Passive, toggleable full-screen CRT/VHS scanline + flicker + tracking-band layer.
// Mirrors the existing .page-filter recipe, gated by a future FloorToolbar switch.
import * as React from "react";
import './vhsoverlay.css';

function VhsOverlay(props) {
    return (
        <div className="vhs-overlay" aria-hidden="true" />
    );
}

export default VhsOverlay;
